export const jottoSecretWordReducer = (state = '', action) => {
    return state;
  };
  